import React, { FC, Fragment, useCallback, useEffect, useState } from 'react';

import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ScannerCasesPageActions from 'components/scanner-cases/dentists/scanner-cases-page-actions.component';
import ScannerCaseTable from 'components/scanner-cases/dentists/scanner-case-table/scanner-case-table.component';
import { ScannerCaseFilter } from 'models/scanner-case';
import { isEqual } from 'lodash';

const DentistScannerCases: FC = () => {
    const { t: translate } = useTranslation(['scan-cases']);
    const [scannerCaseFilter, setScannerCaseFilter] = useState<ScannerCaseFilter>({});

    useEffect(() => {
        setScannerCaseFilter(JSON.parse(localStorage.getItem('scanCaseFilters') || '{}'));
    }, []);

    const handleFilterChange = useCallback(
        (filters: ScannerCaseFilter) => {
            if (!isEqual(filters, scannerCaseFilter)) {
                localStorage.setItem('scannerCaseFilters', JSON.stringify(filters));
                setScannerCaseFilter(filters);
            }
        },
        [scannerCaseFilter],
    );

    return (
        <Fragment>
            <Helmet>
                <title>{translate('scan-cases:SCAN_CASES')} | Denthub</title>
            </Helmet>
            <Box mb={2}>
                <ScannerCasesPageActions initFilters={scannerCaseFilter} onFilterChange={handleFilterChange} />
            </Box>
            <ScannerCaseTable scannerCaseFilter={scannerCaseFilter} />
        </Fragment>
    );
};

export default DentistScannerCases;
